import ApiService from "@/api/apiService";

export type ConfigurationItem = Record<string, string | null>;

export interface Configuration {
  enable: ConfigurationItem;
  debug: ConfigurationItem;
}

export interface GetConfigurationApiResponse {
  data: Configuration;
}

export enum ConfigurationName {
  MY_ACCOUNT = 'myaccount'
}

export function getConfiguration(configurationName: ConfigurationName): Promise<GetConfigurationApiResponse> {
  return ApiService.api.get(`/admin/configurations/${configurationName}`).then(r => r.data);
}

export function postConfiguration(configurationName: ConfigurationName, config: GetConfigurationApiResponse): Promise<GetConfigurationApiResponse> {
  return ApiService.api.post(`/admin/configurations/${configurationName}`, config).then(r => r.data);
}
